import React from "react";
import { CoreMui5Provider, createArgusTheme } from "@mnemonic/mui5";
export default function ThemeProvider({ children, intl, session }) {
    /* Disabling dark mode in swagger until we have a solution that looks better */
    const sessionWithLightMode = {
        ...session,
        user: { ...session?.user, properties: { ...session?.user?.properties, "ui.themeMode": "light" } },
    };
    const theme = createArgusTheme(sessionWithLightMode, (createTheme, localizationOpts) => createTheme(
    // Pass a empty object if there are no local overrides
    {}, ...localizationOpts));
    return (<CoreMui5Provider locale={intl?.locale} domain={session?.user?.domain} theme={theme}>
      {children}
    </CoreMui5Provider>);
}
